import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);  // اسکرول به بالای صفحه هنگام تغییر مسیر
    }, [location]);

    return null;
};

export default ScrollToTop;